<template>
	<!-- 合同签订发起 -->
	<div>
		<div v-show="HtqdFq">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">合同签订发起</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:40px"></div>
					<div style="display:inline-block;margin-left:10px">
						<span>组织架构</span>
						<el-cascader v-model="condition.organize_ids" clearable
						    style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
					</div>

					<div style="display:inline-block;margin-left:20px">
						<span>岗位 </span>
						<el-select v-model="condition.sign_post" style="margin-left:10px;width:180px"
							:placeholder="postPlaceholder" clearable>
							<el-option v-for="item in postList" :key="item.id" :label="item.post_name" :value="item.id">
							</el-option>
						</el-select>
					</div>

					<div style="display:inline-block;margin-left:20px">
						<span>起止时间 </span>
						<el-date-picker v-model="condition.start_stop_date" style="margin-left:10px;" type="daterange"
							value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</div>

					<div style="display:inline-block;margin-left:20px">
						<span>状态 </span>
						<el-select v-model="condition.state" style="margin-left:10px;width:180px" placeholder="请选择"
							clearable>
							<el-option label="未生效" value="0"></el-option>
							<el-option label="已生效" value="1"></el-option>
						</el-select>
					</div>

					<!-- 按钮 -->
					<div style="float:right;margin:1% 3% 0 0 ">
						<el-button type="goon" @click="Find()">查询</el-button>
						<el-button type="goon" @click="Del(null)">删除</el-button>
						<el-button type="addbtn" @click="add()">新增</el-button>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:4% 3% 0 3%">
					<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%" height="574px" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column align="center" label="序号">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column align="center" label="组织架构" width="300">
							<template slot-scope="scope">
								{{ $globals.group_name + '/' + scope.row.range}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="起止日期">
							<template slot-scope="scope">
								{{scope.row.start_date + "—" + scope.row.end_date}}
							</template>
						</el-table-column>
						<el-table-column prop="postString" align="center" label="岗位"></el-table-column>
						<el-table-column prop="templateString" align="center" label="合同模板"></el-table-column>
						<el-table-column align="center" label="状态">
							<template slot-scope="scope">
								<img src="../../../assets/stateImg/状态_已生效.png" v-show="scope.row.state === '1'" />
								<img src="../../../assets/stateImg/状态_未生效.png" v-show="scope.row.state === '0'" />
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="180" fixed="right">
							<template slot-scope="scope">
								<img src="../../../assets/详情.png" @click="xiangqing(scope.row)" />
								<img src="../../../assets/编辑.png" @click="UpdateFrom(scope.row)" />
								<img src="../../../assets/删除.png" @click="Del(scope.row.id)" />
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>

			</div>
		</div>

		<!-- 新增 -->
		<el-dialog :title="from.id != null && from.id != '' ? '修改' : '新增'" :visible.sync="dialogVisible" width="40%"
			:center="true">
			<add ref="adds" v-show="showadd" :organizeList="organizePostList"></add>
		</el-dialog>

		<!-- 详情 -->
		<el-dialog title="详情" :visible.sync="dialogVisibleqing" width="40%" :center="true">
			<edit ref="edits" v-show="showedit" :from="from"></edit>
		</el-dialog>


	</div>
</template>

<script>
	import add from './HtqdFq_add.vue';
	import edit from './HtqdFq_edit.vue';
	export default {
		components: {
			add: add,
			edit: edit,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],

				//条件
				condition: {
					organize_ids: [],
					company_id: "",
					project_id: "",
					sign_post: "",
					start_stop_date: [],
					state: "",
				},

				//详情
				from: {
					id: "",
					project_id: "",
					start_stop_date: [],
					state: "",
					sign_post: [],
					sign_template: [],
					postList: [],
					templateList: [],
					organize_ids : "",
					post_name: "",
					template_name: "",
				},

				//列表ids
				ids: [],
				
				//页面相关
				dialogVisible: false,
				dialogVisibleqing: false,

				// 权限
				HtqdFq: true,
				showadd: false,
				showedit: false,
				
				//模板数据
				templateList: [],
				//岗位数据
				postList: [],
				
				//组织架构数据
				organizeList: [],
				
				//组织架构岗位数据
				organizePostList: [],
				
				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
				    value: "id",
				    label: "organize_name",
				    children: "organizeList",
				    checkStrictly: true,
				    multiple: true,
				},

			}
		},
		methods: {
			//列表点击复选框
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				})
			},
			//查询列表
			async Find() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
				    temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
				    organize_ids += item + ",";
				})
				
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					organize_ids: organize_ids,
					post_id: this.condition.sign_post,
					start_date: this.condition.start_stop_date != null && this.condition.start_stop_date != '' ?
						this.condition.start_stop_date[0] : "",
					end_date: this.condition.start_stop_date != null && this.condition.start_stop_date != '' ?
						this.condition.start_stop_date[1] : "",
					state: this.condition.state,
				};
				var result = await this.$globals.AxiosPost("SignContract/selectAll", record);
				if (result != '-2000') {
					var data = result.data;
					var code = result.code;

					this.tableData = data.list;
					this.total = data.total;

				} else {
					this.$message.error("服务器未响应！请稍后重试");
				}
			},
			//分页查询
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			// 新增
			add() {
				this.trash();
				this.dialogVisible = true;
				this.showadd = true;
			},
			// 操作详情
			xiangqing(e) {
				this.from.id = e.id;
				this.from.project_id = e.project_id;
				this.from.start_stop_date[0] = e.start_date;
				this.from.start_stop_date[1] = e.end_date;
				this.from.state = e.state;
				this.from.range = e.range;
				this.from.postList = e.postList;
				this.from.templateList = e.templateList;
				this.dialogVisibleqing = true;
				this.showedit = true;
			},
			// 操作修改
			UpdateFrom(e) {
				this.from.id = e.id;
				this.from.project_id = e.project_id;
				this.from.start_stop_date[0] = e.start_date;
				this.from.start_stop_date[1] = e.end_date;
				this.from.state = e.state;
				this.from.sign_post = e.sign_post_string.split(',').map(Number);
				this.from.sign_template = e.sign_template_string.split(',').map(Number);
				this.from.organize_ids = e.organize_ids;
				this.dialogVisible = true;
				this.showadd = true;
			},
			// 操作删除
			async Del(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var record = {
					ids: ids,
				};
				var result = await this.$globals.AxiosPost("SignContract/del", record);
				if (result != '-2000') {
					var data = result.data;
					var code = result.code;
					if (code === '200') {
						this.$message.success(data);
						this.Find();
					} else {
						this.$message.warning(data);
					}
				} else {
					this.$message.error("服务器未响应！请稍后重试");
				}
			},
			//清除数据
			trash() {
				this.from.sign_template = [];
				this.from.sign_post = [];
				this.from.state = "";
				this.from.start_stop_date = [];
				this.from.project_id = "";
				this.from.id = "";
			},
			//初始化组织架构及下面的人
			async organizeFind() {
			    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
			        identification: "1",
			    });
			    this.organizeList = this.getTreeData(organizeList.data);
			
			},
			getTreeData(data) {
			    // 循环遍历json数据
			    for (var i = 0; i < data.length; i++) {
			
			        if (data[i].organizeList.length < 1) {
			            // children若为空数组，则将children设为undefined
			            data[i].organizeList = undefined;
			        } else {
			            // children若不为空数组，则继续 递归调用 本方法
			            this.getTreeData(data[i].organizeList);
			        }
			    }
			    return data;
			}
		},
		async created() {
			this.Find();
			this.organizeFind();

			//初始化合同模板数据
			var templateList = await this.$globals.AxiosPost("template/selectAlls", {});
			this.templateList = templateList.data;
			
			//初始化岗位数据
			var postList = await this.$globals.AxiosPost("post/selectFind", {});
			this.postList = postList.data;
			
			//初始化组织架构岗位
			var organizePostList = await this.$globals.AxiosPost("organize/selectOrganizePost", {});
			this.organizePostList = organizePostList.data;
		}
	}
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006E4B;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}

	.el-button--goon {
		color: #FFF;
		background-color: #006E4B;
		border-color: #006E4B;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006E4B;
	}

	.el-checkbox__inner:hover {
		border-color: #006E4B;
	}
</style>



// WEBPACK FOOTER //
// HtqdFq.vue?7fb26820